// Modal general de criterios de priorización (accesible desde el header).
import React from 'react';
import { X } from 'lucide-react';
import { EXPLICACIONES_NIVEL, NIVELES, DISCLAIMER_NIVEL } from '../../../lib/dashboardVocab';

export default function PriorityCriteriaModal({ open, onClose }) {
  if (!open) return null;
  const orden = ['verde', 'amarillo', 'naranjo', 'rojo'];
  return (
    <div
      className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center px-4"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="criterios-title"
      data-testid="criterios-modal-overlay"
    >
      <div
        className="bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto shadow-xl"
        onClick={(e) => e.stopPropagation()}
        data-testid="criterios-modal"
      >
        <div className="px-6 py-4 border-b border-[#E5EAF5] flex items-center justify-between">
          <h2 id="criterios-title" className="font-extrabold text-[#0B1B5E] text-lg">
            Criterios de priorización preventiva
          </h2>
          <button onClick={onClose} className="p-1 rounded hover:bg-[#F4F7FE]" aria-label="Cerrar" data-testid="criterios-close">
            <X className="w-5 h-5 text-[#475472]" />
          </button>
        </div>
        <div className="px-6 py-5 space-y-4">
          {orden.map((k) => {
            const nivel = NIVELES[k];
            const info = EXPLICACIONES_NIVEL[k];
            return (
              <div
                key={k}
                className="rounded-xl border p-4"
                style={{ borderColor: nivel.bg, background: `${nivel.bg}55` }}
                data-testid={`criterio-${k}`}
              >
                <div className="flex items-center gap-2 mb-1">
                  <span className="w-3 h-3 rounded-full" style={{ background: nivel.dot }} />
                  <h3 className="font-bold text-[#0B1B5E]">{info.titulo}</h3>
                </div>
                <p className="text-sm text-[#475472] mb-1"><strong>Situación:</strong> {info.descripcion}</p>
                <p className="text-sm text-[#475472]"><strong>Acción esperada:</strong> {info.accion}</p>
              </div>
            );
          })}
          <div className="mt-4 p-3 rounded-lg bg-[#F4F7FE] text-xs text-[#475472] leading-relaxed border border-[#E5EAF5]" data-testid="criterios-disclaimer">
            {DISCLAIMER_NIVEL}
          </div>
        </div>
      </div>
    </div>
  );
}
